import { ReactElement } from 'react';
import { Tooltip } from '@mui/material';

interface IProps {
  title: string;
  children: ReactElement;
}

export const HoverWrapper = ({ title, children }: IProps) => {
  return (
    <Tooltip id="index__components-hover-wrapper__tooltip__l11"
    slotProps={{
      tooltip: {
        style: {
          borderRadius: '4px'
        }
      }
    }}
    title={title}>
      
      {children}
    </Tooltip>);

};